var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _dec61, _dec62, _dec63, _dec64, _dec65, _dec66, _dec67, _dec68, _dec69, _dec70, _dec71, _dec72, _dec73, _dec74, _dec75, _dec76, _dec77, _dec78, _dec79, _dec80, _dec81, _dec82, _dec83, _dec84, _dec85, _dec86, _dec87, _dec88, _dec89, _dec90, _dec91, _dec92, _dec93, _dec94, _dec95, _dec96, _dec97, _dec98, _dec99, _dec100, _dec101, _dec102, _dec103, _dec104, _dec105, _dec106, _dec107, _dec108, _dec109, _dec110, _dec111, _dec112, _dec113, _dec114, _dec115, _dec116, _dec117, _dec118, _dec119, _dec120, _dec121, _dec122, _dec123, _dec124, _dec125, _dec126, _dec127, _dec128, _dec129, _dec130, _dec131, _dec132, _dec133, _dec134, _dec135, _dec136, _dec137, _dec138, _dec139, _dec140, _dec141, _dec142, _dec143, _dec144, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _descriptor82, _descriptor83, _descriptor84, _descriptor85, _descriptor86, _descriptor87, _descriptor88, _descriptor89, _descriptor90, _descriptor91, _descriptor92, _descriptor93, _descriptor94, _descriptor95, _descriptor96, _descriptor97, _descriptor98, _descriptor99, _descriptor100, _descriptor101, _descriptor102, _descriptor103, _descriptor104, _descriptor105, _descriptor106, _descriptor107, _descriptor108, _descriptor109, _descriptor110, _descriptor111, _descriptor112, _descriptor113, _descriptor114, _descriptor115, _descriptor116, _descriptor117, _descriptor118, _descriptor119, _descriptor120, _descriptor121, _descriptor122, _descriptor123, _descriptor124, _descriptor125, _descriptor126, _descriptor127, _descriptor128, _descriptor129, _descriptor130, _descriptor131, _descriptor132, _descriptor133, _descriptor134, _descriptor135, _descriptor136, _descriptor137, _descriptor138, _descriptor139, _descriptor140, _descriptor141, _descriptor142, _descriptor143, _descriptor144, _descriptor145, _descriptor146, _descriptor147;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo, hasMany } from "@ember-data/model";
import { get } from "@ember/object";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { isBlank } from "@ember/utils";
import { cached } from "@glimmer/tracking";
import BiologicalActRefundedJournalEvent from "cnam/models/biological-act-refunded-journal-event";
import CnamProcessStartedJournalEvent from "cnam/models/cnam-process-started-journal-event";
import DrugsAndDevicesRefundedJournalEvent from "cnam/models/drugs-and-devices-refunded-journal-event";
import HospitalisationRefundedJournalEvent from "cnam/models/hospitalisation-refunded-journal-event";
import MedicalActRefundedJournalEvent from "cnam/models/medical-act-refunded-journal-event";
import MedicalImagingRefundedJournalEvent from "cnam/models/medical-imaging-refunded-journal-event";
import ReimbursementsRetrievedJournalEvent from "cnam/models/reimbursements-retrieved-journal-event";
import { INS, InsIdentityDocumentType, InsOid, InsSex, InsStatus } from "cnam/types/types";
import ComorbiditiesAndAllergiesChangedJournalEvent from "comorbidity/models/comorbidities-and-allergies-changed-journal-event";
import CompoundSurvey from "compound-survey/models/compound-survey";
import CompoundSurveyCompletedJournalEvent from "compound-survey/models/compound-survey-completed-journal-event";
import CompoundSurveyFrequenciesChangedJournalEvent from "compound-survey/models/compound-survey-frequencies-changed-journal-event";
import CompoundSurveyFrequency from "compound-survey/models/compound-survey-frequency";
import PatientAbility from "core/abilities/patient";
import AdherencePredictionComputedJournalEvent from "core/models/adherence-prediction-computed-journal-event";
import BdiIiDeclaredJournalEvent from "core/models/bdi-ii-declared-journal-event";
import BioExamFrequencyChangedJournalEvent from "core/models/bio-exam-frequency-changed-journal-event";
import CrisisPlanDeclaredJournalEvent from "core/models/crisis-plan-declared-journal-event";
import { default as Das28SdaiComputedJournalEvent, default as das28SdaiComputedJournalEvent } from "core/models/das28-sdai-computed-journal-event";
import DataSharingConsentUpdatedJournalEvent from "core/models/data-sharing-consent-updated-journal-event";
import DmpAccessConsentUpdatedJournalEvent from "core/models/dmp-access-consent-updated-journal-event";
import { default as DpCycleDeclaredJournalEvent, default as dpCycleDeclaredJournalEvent } from "core/models/dp-cycle-declared-journal-event";
import HospitalisationRiskPredictionComputedJournalEvent from "core/models/hospitalisation-risk-prediction-computed-journal-event";
import jobsDeclaredJournalEvent from "core/models/jobs-declared-journal-event";
import { default as JournalEvent, default as JournalEventModel } from "core/models/journal-event";
import Medic from "core/models/medic";
import MedicalHistoryChangedJournalEvent from "core/models/medical-history-changed-journal-event";
import MedicsPatient from "core/models/medics-patient";
import PatientDisenrolledJournalEvent from "core/models/patient-disenrolled-journal-event";
import PhqNineDeclaredJournalEvent from "core/models/phq-nine-declared-journal-event";
import TlsTrialPeriodValidatedJournalEvent from "core/models/tls-trial-period-validated-journal-event";
import ToxicityPredictionComputedJournalEvent from "core/models/toxicity-prediction-computed-journal-event";
import WeightMeasuredJournalEvent from "core/models/weight-measured-journal-event";
import SemeiaSessionService from "core/services/session";
import TermsOfUseService from "core/services/terms-of-use";
import { activeJournalEvents } from "core/utils/decorators";
import formatToISO8601Date from "core/utils/format-to-iso8601-date";
import { getJesOfClass, getJesOfClassSince, getJesOfClassSinceYear, getJesSince, getLastJe, getLastJeOfClass } from "core/utils/journal-events";
import removeDiacritics from "core/utils/remove-diacritics";
import { sortBy } from "core/utils/sort";
import dayjs from "dayjs";
import KfreFiveYearsComputedJournalEvent from "pro-irc/models/kfre-five-years-computed-journal-event";
import KfreTwoYearsComputedJournalEvent from "pro-irc/models/kfre-two-years-computed-journal-event";
import ProIrcStatusUpdatedJournalEvent from "pro-irc/models/pro-irc-status-updated-journal-event";
import AbdominalAreaDeclaredJournalEvent from "./abdominal-area-declared-journal-event";
import AdverseEventDeclaredJournalEvent from "./adverse-event-declared-journal-event";
import AlertProcessedJournalEvent from "./alert-processed-journal-event";
import AlertTriggeredJournalEvent from "./alert-triggered-journal-event";
import AnxietyFilledJournalEvent from "./anxiety-filled-journal-event";
import AppUsageConsentUpdatedJournalEvent from "./app-usage-consent-updated-journal-event";
import BioExamExpectedDosageChangedJournalEvent from "./bio-exam-expected-dosage-changed-journal-event";
import BioExamPrescribedJournalEvent from "./bio-exam-prescribed-journal-event";
import BioExamResult from "./bio-exam-result";
import BioExamResultsReceivedJournalEvent from "./bio-exam-results-received-journal-event";
import BloodPressureSessionStartedJournalEvent from "./blood-pressure-session-started-journal-event";
import CapillarityBloodGlucoseMeasuredJournalEvent from "./capillarity-blood-glucose-measured-journal-event";
import CareGiverAddedJournalEvent from "./care-giver-added-journal-event";
import ConnectedDeviceAcquiredJournalEvent from "./connected-device-acquired-journal-event";
import ConnectedDeviceLinkedJournalEvent from "./connected-device-linked-journal-event";
import ConsultationPlannedJournalEvent from "./consultation-planned-journal-event";
import ConsultationReportWrittenJournalEvent from "./consultation-report-written-journal-event";
import Creator from "./creator";
import CrohnSurveyFilledJournalEvent from "./crohn-survey-filled-journal-event";
import CtcaeFilledJournalEvent from "./ctcae-filled-journal-event";
import Das28CdaiComputedJournalEvent from "./das28-cdai-computed-journal-event";
import Das28CrpComputedJournalEvent from "./das28-crp-computed-journal-event";
import Das28VsComputedJournalEvent from "./das28-vs-computed-journal-event";
import DiabetowiseDischargeCompletedJournalEvent from "./diabetowise-discharge-completed-journal-event";
import DiabguideRecommendationComputedJournalEvent from "./diabguide-recommendation-computed-journal-event";
import DigitalCareDeclaredJournalEvent from "./digital-care-declared-journal-event";
import DisorderHistoryDeclaredJournalEvent from "./disorder-history-declared-journal-event";
import FastDeclaredJournalEvent from "./fast-declared-journal-event";
import FeelingEvasDeclaredJournalEvent from "./feeling-evas-declared-journal-event";
import FileAttachment from "./file-attachment";
import FileUploadedJournalEvent from "./file-uploaded-journal-event";
import FollowUpReason from "./follow-up-reason";
import GenericPrescriptionUploadedJournalEvent from "./generic-prescription-uploaded-journal-event";
import HealthCentre from "./health-centre";
import HeightMeasuredJournalEvent from "./height-measured-journal-event";
import HemodialysisSessionDeclaredJournalEvent from "./hemodialysis-session-declared-journal-event";
import IbdDiskSurveyFilledJournalEvent from "./ibd-disk-survey-filled-journal-event";
import InflammatoryEruptionDeclaredJournalEvent from "./inflammatory-eruption-declared-journal-event";
import InterTreatmentFilledJournalEvent from "./inter-treatment-filled-journal-event";
import LifestyleDeclaredJournalEvent from "./lifestyle-declared-journal-event";
import BioExamObservation from "./loinc";
import MedicalActFrequencyChangedJournalEvent from "./medical-act-frequency-changed-journal-event";
import MedicalEventJournalEvent from "./medical-event-journal-event";
import MedicalImagingPrescribedJournalEvent from "./medical-imaging-prescribed-journal-event";
import MedicationPrescribedJournalEvent from "./medication-prescribed-journal-event";
import MedicinesReconciliationChangedJournalEvent from "./medicines-reconciliation-changed-journal-event";
import MobilePassiveDataDailySnapshotJournalEvent from "./mobile-passive-data-daily-snapshot-journal-event";
import MrcReplacementJournalEvent from "./mrc-replacement-journal-event";
import OkChimioSnapshotCapturedJournalEvent from "./ok-chimio-snapshot-captured-journal-event";
import OnlineConsultationReportWrittenJournalEvent from "./online-consultation-report-written-journal-event";
import OxygeneSaturationDeclaredJournalEvent from "./oxygene-saturation-declared-journal-event";
import ParamedicalCarePrescribedJournalEvent from "./paramedical-care-prescribed-journal-event";
import PatientChatMessageSentJournalEvent from "./patient-chat-message-sent-journal-event";
import PatientEnrolledJournalEvent from "./patient-enrolled-journal-event";
import PatientInformationTransmittedJournalEvent from "./patient-information-transmitted-journal-event";
import PersonalNotesChangedJournalEvent from "./personal-notes-changed-journal-event";
import PostSurgerySurveyFilledJournalEvent from "./post-surgery-survey-filled-journal-event";
import PrArticulationsCountedJournalEvent from "./pr-articulations-counted-journal-event";
import PrFeelingEvaMedicDeclaredJournalEvent from "./pr-feeling-eva-medic-declared-journal-event";
import PrFeelingEvaPatientDeclaredJournalEvent from "./pr-feeling-eva-patient-declared-journal-event";
import PreSurgerySurveyFilledJournalEvent from "./pre-surgery-survey-filled-journal-event";
import PreTreatmentFilledJournalEvent from "./pre-treatment-filled-journal-event";
import PrescriptionJournalEvent from "./prescription-journal-event";
import QidsDeclaredJournalEvent from "./qids-declared-journal-event";
import RchSurveyFilledJournalEvent from "./rch-survey-filled-journal-event";
import RecursiveTaskPlannedJournalEvent from "./recursive-task-planned-journal-event";
import ReferentLabUpdatedJournalEvent from "./referent-lab-updated-journal-event";
import RespiratoryRateMeasuredJournalEvent from "./respiratory-rate-measured-journal-event";
import SpirometerAssociatedJournalEvent from "./spirometer-associated-journal-event";
import StoolsNumberDeclaredJournalEvent from "./stools-number-declared-journal-event";
import SurveyCompletedJournalEvent from "./survey-completed-journal-event";
import SurveyRequestedJournalEvent from "./survey-requested-journal-event";
import TaskPlannedJournalEvent from "./task-planned-journal-event";
import TaskProcessedJournalEvent from "./task-processed-journal-event";
import TemperatureMeasuredJournalEvent from "./temperature-measured-journal-event";
import TherapeuticAssistanceSessionCompletedJournalEvent from "./therapeutic-assistance-session-completed-journal-event";
import TherapeuticalArea from "./therapeutical-area";
import ThreeMonthsGoalsJournalEvent from "./three-months-goals-journal-event";
import ThymicEpisodeOccurredJournalEvent from "./thymic-episode-occurred-journal-event";
import TlsConsentUpdatedJournalEvent from "./tls-consent-updated-journal-event";
import TlsPrescribedJournalEvent from "./tls-prescribed-journal-event";
import TreatmentHistoryChangedJournalEvent from "./treatment-history-changed-journal-event";
import TreatmentPrescriptionChangedJournalEvent from "./treatment-prescription-changed-journal-event";
import VemsDeclaredJournalEvent from "./vems-declared-journal-event";
import YmrsDeclaredJournalEvent from "./ymrs-declared-journal-event";
let Patient = (_dec = attr("string"), _dec2 = attr("string"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("date"), _dec6 = attr("string"), _dec7 = attr("string"), _dec8 = attr("number"), _dec9 = attr("string"), _dec10 = attr("string"), _dec11 = attr("string"), _dec12 = attr("string"), _dec13 = attr("string"), _dec14 = attr("string"), _dec15 = attr("string"), _dec16 = attr("date"), _dec17 = attr("boolean"), _dec18 = attr("date"), _dec19 = attr("number"), _dec20 = attr("string"), _dec21 = attr("string"), _dec22 = attr("string"), _dec23 = attr("string"), _dec24 = attr("string"), _dec25 = attr("string"), _dec26 = attr("string"), _dec27 = attr("string"), _dec28 = attr("string"), _dec29 = attr("string"), _dec30 = attr("boolean"), _dec31 = attr("string"), _dec32 = attr(), _dec33 = attr("date"), _dec34 = attr("boolean"), _dec35 = attr("boolean"), _dec36 = attr({
  defaultValue() {
    return {};
  }
}), _dec37 = hasMany("file-attachment", {
  async: false,
  inverse: "patient"
}), _dec38 = hasMany("journal-event", {
  polymorphic: true,
  async: false,
  inverse: "patient"
}), _dec39 = hasMany("patient-chat-message-sent-journal-event", {
  async: false,
  inverse: "patient"
}), _dec40 = belongsTo("patient-enrolled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec41 = belongsTo("patient-disenrolled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec42 = belongsTo("comorbidities-and-allergies-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec43 = belongsTo("medical-history-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec44 = belongsTo("adherence-prediction-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec45 = belongsTo("mobile-passive-data-daily-snapshot-journal-event", {
  async: false,
  inverse: "patient"
}), _dec46 = belongsTo("medical-act-frequency-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec47 = belongsTo("patient-information-transmitted-journal-event", {
  async: false,
  inverse: "patient"
}), _dec48 = belongsTo("tls-consent-updated-journal-event", {
  async: false,
  inverse: "patient"
}), _dec49 = belongsTo("pro-irc-status-updated-journal-event", {
  async: false,
  inverse: "patient"
}), _dec50 = belongsTo("hospitalisation-risk-prediction-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec51 = belongsTo("spirometer-associated-journal-event", {
  async: false,
  inverse: "patient"
}), _dec52 = belongsTo("mrc-replacement-journal-event", {
  async: false,
  inverse: "patient"
}), _dec53 = belongsTo("personal-notes-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec54 = hasMany("temperature-measured-journal-event", {
  async: false,
  inverse: "patient"
}), _dec55 = hasMany("kfre-five-years-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec56 = hasMany("kfre-two-years-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec57 = hasMany("weight-measured-journal-event", {
  async: false,
  inverse: "patient"
}), _dec58 = hasMany("height-measured-journal-event", {
  async: false,
  inverse: "patient"
}), _dec59 = hasMany("capillarity-blood-glucose-measured-journal-event", {
  async: false,
  inverse: "patient"
}), _dec60 = hasMany("respiratory-rate-measured-journal-event", {
  async: false,
  inverse: "patient"
}), _dec61 = hasMany("adverse-event-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec62 = hasMany("feeling-evas-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec63 = hasMany("medical-event-journal-event", {
  async: false,
  inverse: "patient"
}), _dec64 = hasMany("compound-survey-completed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec65 = hasMany("blood-pressure-session-started-journal-event", {
  async: false,
  inverse: "patient"
}), _dec66 = hasMany("bio-exam-results-received-journal-event", {
  async: false,
  inverse: "patient"
}), _dec67 = hasMany("bio-exam-frequency-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec68 = hasMany("medication-prescribed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec69 = hasMany("tls-prescribed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec70 = hasMany("alert-triggered-journal-event", {
  async: false,
  inverse: "patient"
}), _dec71 = hasMany("alert-processed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec72 = hasMany("care-giver-added-journal-event", {
  async: false,
  inverse: "patient"
}), _dec73 = belongsTo("toxicity-prediction-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec74 = hasMany("bio-exam-prescribed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec75 = hasMany("consultation-report-written-journal-event", {
  async: false,
  inverse: "patient"
}), _dec76 = hasMany("connected-device-linked-journal-event", {
  async: false,
  inverse: "patient"
}), _dec77 = hasMany("file-uploaded-journal-event", {
  async: false,
  inverse: "patient"
}), _dec78 = hasMany("generic-prescription-uploaded-journal-event", {
  async: false,
  inverse: "patient"
}), _dec79 = hasMany("medical-imaging-prescribed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec80 = hasMany("paramedical-care-prescribed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec81 = hasMany("survey-completed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec82 = hasMany("consultation-planned-journal-event", {
  async: false,
  inverse: "patient"
}), _dec83 = hasMany("online-consultation-report-written-journal-event", {
  async: false,
  inverse: "patient"
}), _dec84 = hasMany("task-planned-journal-event", {
  async: false,
  inverse: "patient"
}), _dec85 = hasMany("recursive-task-planned-journal-event", {
  async: false,
  inverse: "patient"
}), _dec86 = hasMany("task-processed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec87 = hasMany("treatment-prescription-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec88 = hasMany("connected-device-acquired-journal-event", {
  async: false,
  inverse: "patient"
}), _dec89 = hasMany("therapeutic-assistance-session-completed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec90 = hasMany("bio-exam-expected-dosage-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec91 = hasMany("ok-chimio-snapshot-captured-journal-event", {
  async: false,
  inverse: "patient"
}), _dec92 = hasMany("biological-act-refunded-journal-event", {
  async: false,
  inverse: "patient"
}), _dec93 = hasMany("drugs-and-devices-refunded-journal-event", {
  async: false,
  inverse: "patient"
}), _dec94 = hasMany("hospitalisation-refunded-journal-event", {
  async: false,
  inverse: "patient"
}), _dec95 = hasMany("medical-act-refunded-journal-event", {
  async: false,
  inverse: "patient"
}), _dec96 = hasMany("medical-imaging-refunded-journal-event", {
  async: false,
  inverse: "patient"
}), _dec97 = hasMany("ymrs-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec98 = hasMany("qids-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec99 = hasMany("fast-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec100 = hasMany("thymic-episode-occurred-journal-event", {
  async: false,
  inverse: "patient"
}), _dec101 = hasMany("diabguide-recommendation-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec102 = belongsTo("treatment-history-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec103 = belongsTo("app-usage-consent-updated-journal-event", {
  async: false,
  inverse: "patient"
}), _dec104 = belongsTo("dmp-access-consent-updated-journal-event", {
  async: false,
  inverse: "patient"
}), _dec105 = belongsTo("data-sharing-consent-updated-journal-event", {
  async: false,
  inverse: "patient"
}), _dec106 = belongsTo("crisis-plan-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec107 = belongsTo("digital-care-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec108 = hasMany("oxygene-saturation-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec109 = hasMany("vems-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec110 = hasMany("medicines-reconciliation-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec111 = hasMany("survey-requested-journal-event", {
  async: false,
  inverse: "patient"
}), _dec112 = belongsTo("compound-survey-frequencies-changed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec113 = belongsTo("tls-trial-period-validated-journal-event", {
  async: false,
  inverse: "patient"
}), _dec114 = hasMany("medic", {
  async: false,
  inverse: null
}), _dec115 = hasMany("medics-patient", {
  async: false,
  inverse: "patient"
}), _dec116 = belongsTo("health-centre", {
  async: false,
  inverse: "patients"
}), _dec117 = hasMany("hemodialysis-session-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec118 = hasMany("dp-cycle-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec119 = hasMany("abdominal-area-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec120 = hasMany("three-months-goals-journal-event", {
  async: false,
  inverse: "patient"
}), _dec121 = belongsTo("lifestyle-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec122 = belongsTo("jobs-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec123 = belongsTo("disorder-history-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec124 = belongsTo("referent-lab-updated-journal-event", {
  async: false,
  inverse: "patient"
}), _dec125 = belongsTo("cnam-process-started-journal-event", {
  async: false,
  inverse: "patient"
}), _dec126 = hasMany("das28-crp-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec127 = hasMany("das28-vs-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec128 = hasMany("das28-cdai-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec129 = hasMany("das28-sdai-computed-journal-event", {
  async: false,
  inverse: "patient"
}), _dec130 = hasMany("pr-articulations-counted-journal-event", {
  async: false,
  inverse: "patient"
}), _dec131 = hasMany("pr-feeling-eva-patient-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec132 = hasMany("pr-feeling-eva-medic-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec133 = hasMany("inflammatory-eruption-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec134 = hasMany("ctcae-filled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec135 = hasMany("pre-treatment-filled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec136 = hasMany("inter-treatment-filled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec137 = hasMany("anxiety-filled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec138 = hasMany("pre-surgery-survey-filled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec139 = hasMany("post-surgery-survey-filled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec140 = hasMany("rch-survey-filled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec141 = hasMany("crohn-survey-filled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec142 = hasMany("stools-number-declared-journal-event", {
  async: false,
  inverse: "patient"
}), _dec143 = hasMany("ibd-disk-survey-filled-journal-event", {
  async: false,
  inverse: "patient"
}), _dec144 = belongsTo("diabetowise-discharge-completed-journal-event", {
  async: false,
  inverse: "patient"
}), _class = class Patient extends Creator {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "abilities", _descriptor, this);
    _initializerDefineProperty(this, "termsOfUse", _descriptor2, this);
    _initializerDefineProperty(this, "session", _descriptor3, this);
    _initializerDefineProperty(this, "birthName", _descriptor4, this);
    _initializerDefineProperty(this, "gender", _descriptor5, this);
    _initializerDefineProperty(this, "occupation", _descriptor6, this);
    _initializerDefineProperty(this, "email", _descriptor7, this);
    _initializerDefineProperty(this, "birthday", _descriptor8, this);
    _initializerDefineProperty(this, "socialSecurityNumber", _descriptor9, this);
    _initializerDefineProperty(this, "insuredSocialSecurityNumber", _descriptor10, this);
    _initializerDefineProperty(this, "birthrank", _descriptor11, this);
    _initializerDefineProperty(this, "computedNationalHealthNumber", _descriptor12, this);
    _initializerDefineProperty(this, "ippNumber", _descriptor13, this);
    _initializerDefineProperty(this, "address", _descriptor14, this);
    _initializerDefineProperty(this, "postcode", _descriptor15, this);
    _initializerDefineProperty(this, "city", _descriptor16, this);
    _initializerDefineProperty(this, "moreAddressInformation", _descriptor17, this);
    _initializerDefineProperty(this, "phone", _descriptor18, this);
    _initializerDefineProperty(this, "insuranceAldStartDate", _descriptor19, this);
    _initializerDefineProperty(this, "insuranceCmuc", _descriptor20, this);
    _initializerDefineProperty(this, "createdAt", _descriptor21, this);
    _initializerDefineProperty(this, "acceptedTermsOfUseVersion", _descriptor22, this);
    _initializerDefineProperty(this, "uuid", _descriptor23, this);
    _initializerDefineProperty(this, "birthFirstName", _descriptor24, this);
    _initializerDefineProperty(this, "firstBirthFirstName", _descriptor25, this);
    _initializerDefineProperty(this, "birthPlace", _descriptor26, this);
    _initializerDefineProperty(this, "birthMunicipalityCode", _descriptor27, this);
    _initializerDefineProperty(this, "insOid", _descriptor28, this);
    _initializerDefineProperty(this, "insIdentityDocument", _descriptor29, this);
    _initializerDefineProperty(this, "insValue", _descriptor30, this);
    _initializerDefineProperty(this, "insKey", _descriptor31, this);
    _initializerDefineProperty(this, "insStatus", _descriptor32, this);
    _initializerDefineProperty(this, "insDocumentIsQualifying", _descriptor33, this);
    _initializerDefineProperty(this, "clinicalStudyId", _descriptor34, this);
    _initializerDefineProperty(this, "contactPreferences", _descriptor35, this);
    _initializerDefineProperty(this, "passwordChangedAt", _descriptor36, this);
    _initializerDefineProperty(this, "refreshTokensEnabled", _descriptor37, this);
    _initializerDefineProperty(this, "twoFactorAuthenticationEnabled", _descriptor38, this);
    _initializerDefineProperty(this, "associatedData", _descriptor39, this);
    _initializerDefineProperty(this, "fileAttachments", _descriptor40, this);
    /**********************************/
    /*          JOURNAL EVENTS        */
    /**********************************/
    _initializerDefineProperty(this, "journalEvents", _descriptor41, this);
    _initializerDefineProperty(this, "patientChatMessageSentJournalEvents", _descriptor42, this);
    _initializerDefineProperty(this, "patientEnrolledJournalEvent", _descriptor43, this);
    _initializerDefineProperty(this, "patientDisenrolledJournalEvent", _descriptor44, this);
    _initializerDefineProperty(this, "comorbiditiesAndAllergiesChangedJournalEvent", _descriptor45, this);
    _initializerDefineProperty(this, "medicalHistoryChangedJournalEvent", _descriptor46, this);
    _initializerDefineProperty(this, "adherencePredictionComputedJournalEvent", _descriptor47, this);
    _initializerDefineProperty(this, "mobilePassiveDataDailySnapshotJournalEvent", _descriptor48, this);
    _initializerDefineProperty(this, "medicalActFrequencyChangedJournalEvent", _descriptor49, this);
    _initializerDefineProperty(this, "patientInformationTransmittedJournalEvent", _descriptor50, this);
    _initializerDefineProperty(this, "tlsConsentUpdatedJournalEvent", _descriptor51, this);
    _initializerDefineProperty(this, "proIrcStatusUpdatedJournalEvent", _descriptor52, this);
    _initializerDefineProperty(this, "hospitalisationRiskPredictionComputedJournalEvent", _descriptor53, this);
    _initializerDefineProperty(this, "spirometerAssociatedJournalEvent", _descriptor54, this);
    _initializerDefineProperty(this, "mrcReplacementJournalEvent", _descriptor55, this);
    _initializerDefineProperty(this, "personalNotesChangedJournalEvent", _descriptor56, this);
    _initializerDefineProperty(this, "temperatureMeasuredJournalEvents", _descriptor57, this);
    _initializerDefineProperty(this, "kfreFiveYearsComputedJournalEvents", _descriptor58, this);
    _initializerDefineProperty(this, "kfreTwoYearsComputedJournalEvents", _descriptor59, this);
    _initializerDefineProperty(this, "weightMeasuredJournalEvents", _descriptor60, this);
    _initializerDefineProperty(this, "heightMeasuredJournalEvents", _descriptor61, this);
    _initializerDefineProperty(this, "capillarityBloodGlucoseMeasuredJournalEvents", _descriptor62, this);
    _initializerDefineProperty(this, "respiratoryRateMeasuredJournalEvents", _descriptor63, this);
    _initializerDefineProperty(this, "adverseEventDeclaredJournalEvents", _descriptor64, this);
    _initializerDefineProperty(this, "feelingEvasDeclaredJournalEvents", _descriptor65, this);
    _initializerDefineProperty(this, "medicalEventJournalEvents", _descriptor66, this);
    _initializerDefineProperty(this, "compoundSurveyCompletedJournalEvents", _descriptor67, this);
    _initializerDefineProperty(this, "bloodPressureSessionStartedJournalEvents", _descriptor68, this);
    _initializerDefineProperty(this, "bioExamResultsReceivedJournalEvents", _descriptor69, this);
    _initializerDefineProperty(this, "bioExamFrequencyChangedJournalEvents", _descriptor70, this);
    _initializerDefineProperty(this, "medicationPrescribedJournalEvents", _descriptor71, this);
    _initializerDefineProperty(this, "tlsPrescribedJournalEvents", _descriptor72, this);
    _initializerDefineProperty(this, "alertTriggeredJournalEvents", _descriptor73, this);
    _initializerDefineProperty(this, "alertProcessedJournalEvents", _descriptor74, this);
    _initializerDefineProperty(this, "careGiverAddedJournalEvents", _descriptor75, this);
    _initializerDefineProperty(this, "toxicityPredictionComputedJournalEvent", _descriptor76, this);
    _initializerDefineProperty(this, "bioExamPrescribedJournalEvents", _descriptor77, this);
    _initializerDefineProperty(this, "consultationReportWrittenJournalEvents", _descriptor78, this);
    _initializerDefineProperty(this, "connectedDeviceLinkedJournalEvents", _descriptor79, this);
    _initializerDefineProperty(this, "fileUploadedJournalEvents", _descriptor80, this);
    _initializerDefineProperty(this, "genericPrescriptionUploadedJournalEvents", _descriptor81, this);
    _initializerDefineProperty(this, "medicalImagingPrescribedJournalEvents", _descriptor82, this);
    _initializerDefineProperty(this, "paramedicalCarePrescribedJournalEvents", _descriptor83, this);
    _initializerDefineProperty(this, "surveyCompletedJournalEvents", _descriptor84, this);
    _initializerDefineProperty(this, "consultationPlannedJournalEvents", _descriptor85, this);
    _initializerDefineProperty(this, "onlineConsultationReportWrittenJournalEvents", _descriptor86, this);
    _initializerDefineProperty(this, "taskPlannedJournalEvents", _descriptor87, this);
    _initializerDefineProperty(this, "recursiveTaskPlannedJournalEvents", _descriptor88, this);
    _initializerDefineProperty(this, "taskProcessedJournalEvents", _descriptor89, this);
    _initializerDefineProperty(this, "treatmentPrescriptionChangedJournalEvents", _descriptor90, this);
    _initializerDefineProperty(this, "connectedDeviceAcquiredJournalEvents", _descriptor91, this);
    _initializerDefineProperty(this, "therapeuticAssistanceSessionCompletedJournalEvents", _descriptor92, this);
    _initializerDefineProperty(this, "bioExamExpectedDosageChangedJournalEvents", _descriptor93, this);
    _initializerDefineProperty(this, "okChimioSnapshotCapturedJournalEvents", _descriptor94, this);
    _initializerDefineProperty(this, "biologicalActRefundedJournalEvents", _descriptor95, this);
    _initializerDefineProperty(this, "drugsAndDevicesRefundedJournalEvents", _descriptor96, this);
    _initializerDefineProperty(this, "hospitalisationRefundedJournalEvents", _descriptor97, this);
    _initializerDefineProperty(this, "medicalActRefundedJournalEvents", _descriptor98, this);
    _initializerDefineProperty(this, "medicalImagingRefundedJournalEvents", _descriptor99, this);
    _initializerDefineProperty(this, "ymrsDeclaredJournalEvents", _descriptor100, this);
    _initializerDefineProperty(this, "qidsDeclaredJournalEvents", _descriptor101, this);
    _initializerDefineProperty(this, "fastDeclaredJournalEvents", _descriptor102, this);
    _initializerDefineProperty(this, "thymicEpisodeOccurredJournalEvents", _descriptor103, this);
    _initializerDefineProperty(this, "diabguideRecommendationComputedJournalEvents", _descriptor104, this);
    _initializerDefineProperty(this, "treatmentHistoryChangedJournalEvent", _descriptor105, this);
    _initializerDefineProperty(this, "appUsageConsentUpdatedJournalEvent", _descriptor106, this);
    _initializerDefineProperty(this, "dmpAccessConsentUpdatedJournalEvent", _descriptor107, this);
    _initializerDefineProperty(this, "dataSharingConsentUpdatedJournalEvent", _descriptor108, this);
    _initializerDefineProperty(this, "crisisPlanDeclaredJournalEvent", _descriptor109, this);
    _initializerDefineProperty(this, "digitalCareDeclaredJournalEvent", _descriptor110, this);
    _initializerDefineProperty(this, "oxygeneSaturationDeclaredJournalEvents", _descriptor111, this);
    _initializerDefineProperty(this, "vemsDeclaredJournalEvents", _descriptor112, this);
    _initializerDefineProperty(this, "medicinesReconciliationChangedJournalEvents", _descriptor113, this);
    _initializerDefineProperty(this, "surveyRequestedJournalEvents", _descriptor114, this);
    _initializerDefineProperty(this, "compoundSurveyFrequenciesChangedJournalEvent", _descriptor115, this);
    _initializerDefineProperty(this, "tlsTrialPeriodValidatedJournalEvent", _descriptor116, this);
    _initializerDefineProperty(this, "medics", _descriptor117, this);
    _initializerDefineProperty(this, "medicsPatients", _descriptor118, this);
    _initializerDefineProperty(this, "healthCentre", _descriptor119, this);
    // Nephrowise specific
    _initializerDefineProperty(this, "hemodialysisSessionDeclaredJournalEvents", _descriptor120, this);
    _initializerDefineProperty(this, "dpCycleDeclaredJournalEvents", _descriptor121, this);
    // Mentalwise specific
    _initializerDefineProperty(this, "abdominalAreaDeclaredJournalEvents", _descriptor122, this);
    _initializerDefineProperty(this, "threeMonthsGoalsJournalEvents", _descriptor123, this);
    _initializerDefineProperty(this, "lifestyleDeclaredJournalEvent", _descriptor124, this);
    _initializerDefineProperty(this, "jobsDeclaredJournalEvent", _descriptor125, this);
    _initializerDefineProperty(this, "disorderHistoryDeclaredJournalEvent", _descriptor126, this);
    _initializerDefineProperty(this, "referentLabUpdatedJournalEvent", _descriptor127, this);
    _initializerDefineProperty(this, "cnamProcessStartedJournalEvent", _descriptor128, this);
    // Rhumatowise specific
    _initializerDefineProperty(this, "das28CrpComputedJournalEvents", _descriptor129, this);
    _initializerDefineProperty(this, "das28VsComputedJournalEvents", _descriptor130, this);
    _initializerDefineProperty(this, "das28CdaiComputedJournalEvents", _descriptor131, this);
    _initializerDefineProperty(this, "das28SdaiComputedJournalEvents", _descriptor132, this);
    _initializerDefineProperty(this, "prArticulationsCountedJournalEvents", _descriptor133, this);
    _initializerDefineProperty(this, "prFeelingEvaPatientDeclaredJournalEvents", _descriptor134, this);
    _initializerDefineProperty(this, "prFeelingEvaMedicDeclaredJournalEvents", _descriptor135, this);
    _initializerDefineProperty(this, "inflammatoryEruptionDeclaredJournalEvents", _descriptor136, this);
    _initializerDefineProperty(this, "ctcaeFilledJournalEvents", _descriptor137, this);
    _initializerDefineProperty(this, "preTreatmentFilledJournalEvents", _descriptor138, this);
    _initializerDefineProperty(this, "interTreatmentFilledJournalEvents", _descriptor139, this);
    _initializerDefineProperty(this, "anxietyFilledJournalEvents", _descriptor140, this);
    _initializerDefineProperty(this, "preSurgerySurveyFilledJournalEvents", _descriptor141, this);
    _initializerDefineProperty(this, "postSurgerySurveyFilledJournalEvents", _descriptor142, this);
    _initializerDefineProperty(this, "rchSurveyFilledJournalEvents", _descriptor143, this);
    _initializerDefineProperty(this, "crohnSurveyFilledJournalEvents", _descriptor144, this);
    _initializerDefineProperty(this, "stoolsNumberDeclaredJournalEvents", _descriptor145, this);
    _initializerDefineProperty(this, "ibdDiskSurveyFilledJournalEvents", _descriptor146, this);
    _initializerDefineProperty(this, "diabetowiseDischargeCompletedJournalEvent", _descriptor147, this);
  }
  get hasOngoingMiciSurveyProcedure() {
    return this.taskPlannedJournalEvents.some(event => event.responsibleType === "patient" && event.responsibleId === Number(this.id) && (event.taskType === "measure-vital-sign-rch-survey" || event.taskType === "measure-vital-sign-crohn-survey") && event.remindResponsible === true && dayjs().isBefore(event.occurredAt));
  }
  get isAcceptedTermsOfUse() {
    return this.acceptedTermsOfUseVersion == this.termsOfUse.currentVersion;
  }
  get insRetrieved() {
    return [InsStatus.Recovered, InsStatus.Qualified].includes(this.insStatus);
  }
  get ins() {
    if ((this.insStatus == InsStatus.Qualified || this.insStatus == InsStatus.Recovered) && this.insOid && this.birthMunicipalityCode) {
      let sex = InsSex.Unknown;
      switch (this.gender) {
        case "male":
          sex = InsSex.Male;
          break;
        case "female":
          sex = InsSex.Female;
          break;
      }
      return {
        ins: {
          value: `${this.insValue}${this.insKey}`,
          oid: this.insOid
        },
        birthGivenName: this.birthFirstName,
        birthName: this.birthName,
        sex,
        birthPlaceCode: this.birthMunicipalityCode,
        birthDate: formatToISO8601Date(this.birthday)
      };
    }
    return undefined;
  }
  get referentMedic() {
    // return this.medicsPatients.find(mp => mp.role == "referent_medic")?.medic;
    return this.medics[0];
  }
  get age() {
    const years = dayjs().diff(this.birthday, "year");
    const birthday = dayjs(this.birthday).add(years, "year");
    // If the birthday for this year has not occurred yet, subtract 1 from the age
    return dayjs().isBefore(birthday) ? years - 1 : years;
  }
  get fullAddress() {
    const {
      address,
      postcode,
      city,
      moreAddressInformation
    } = this;
    let fullAdd = "";
    if (!isBlank(address)) fullAdd += address;
    if (!isBlank(address) && (!isBlank(postcode) || !isBlank(city))) {
      fullAdd += "<br>";
    }
    if (!isBlank(postcode)) fullAdd += postcode;
    if (!isBlank(postcode) && !isBlank(city)) {
      fullAdd += " ";
    }
    if (!isBlank(city)) fullAdd += city;
    if (!isBlank(moreAddressInformation)) {
      fullAdd += "<br>" + this.moreAddressInformation;
    }
    return fullAdd === "" ? null : htmlSafe(fullAdd);
  }
  get code() {
    if (this.therapeuticalArea?.id == "mental") return this.clinicalStudyId;
    return this.id;
  }
  get initials() {
    return [this.firstName?.charAt(0), this.lastName?.charAt(0)].join("").trim();
  }
  get patientAge() {
    return dayjs().diff(this.birthday, "years");
  }
  get lastPasswordEditDate() {
    return this.passwordChangedAt;
  }
  get shouldChangePassword() {
    // If patient has never set its password return false
    if (!this.passwordChangedAt) return false;
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    // Otherwise return true if password edit date is one year old
    return this.passwordChangedAt < oneYearAgo;
  }
  get patientAbility() {
    return this.abilities.abilityFor("patient", this);
  }
  get availableSurveys() {
    return this.healthCentre.surveys;
  }
  get enabledSurveys() {
    return this.enabledSurveyFrequencies.map(freq => this.store.peekRecord("compound-survey", freq.surveyId));
  }
  get enabledSurveyFrequencies() {
    return this.compoundSurveyFrequenciesChangedJournalEvent?.enabledSurveyFrequencies || [];
  }

  /**
   * Return CompoundSurveyFrequencies for every avaliable CompoundSurvey
   */
  get surveyFrequencies() {
    // Find or create a SurveyFrequency for each available CompoundSurvey
    return this.availableSurveys.map(survey => this.enabledSurveyFrequencies.find(f => f.surveyId == survey.id) || new CompoundSurveyFrequency(survey));
  }
  get isReadOnly() {
    return this.isDisenrolled || !this.patientAbility.canEdit;
  }
  get activeJournalEvents() {
    return this.journalEvents.filter(je => !je.isArchived);
  }

  // TODO: we should add a test to check this logic.
  /**
   * Patient created, but not yet included (nor removed).
   * This accessor is here because for some parogs, the inclusion doesn't have the same sense.
   */
  get isNotYetEnrolled() {
    return !this.isEnrolled && !this.isDisenrolled;
  }

  // TODO: we should add a test to check this logic.
  /**
   * Is the patient already included in the program?
   * This accessor is here because for some parogs, the inclusion doesn't have the same sense.
   */
  get isEnrolled() {
    return !!this.patientEnrolledJournalEvent && !this.isDisenrolled;
  }

  // TODO: we should add a test to check this logic.
  /**
   * Patient specifically removed from the program?
   * This accessor is here because for some parogs, the inclusion doesn't have the same sense.
   */
  get isDisenrolled() {
    return Boolean(this.patientDisenrolledJournalEvent);
  }
  get adherenceScoreCategory() {
    if (this.adherencePredictionComputedJournalEvent?.warnings) {
      return "non calculable";
    }
    return this.adherencePredictionComputedJournalEvent?.averageScoreCategory || "inconnu";
  }
  get toxicityScoreCategory() {
    const je = this.toxicityPredictionComputedJournalEvent;
    if (je?.warnings) {
      return "non calculable";
    }
    return je?.toxicityScoreCategory || "inconnu";
  }
  get hospitalisationScoreCategory() {
    const je = this.hospitalisationRiskPredictionComputedJournalEvent;
    if (je?.warnings) {
      return "non calculable";
    }
    return je?.hospitalisationScoreCategory || "inconnu";
  }

  /**
   * Disenroll the patient.
   *
   * @param reason - The reason of the disenrollment. Free text, but a
   *   key is recommended.
   */
  async disenroll(reason, occurredAt = new Date()) {
    const disenrolled = this.store.createRecord("patient-disenrolled-journal-event", {
      patient: this,
      occurredAt,
      reason
    });
    return disenrolled.save();
  }

  /**
   * Check if the patient matches the given data.
   * return Is the patient matching the given data.
   */

  isMatching(options) {
    const {
      firstName,
      lastName,
      birthdate
    } = options;
    let {
      birthday
    } = options;
    function clearTrait(trait) {
      return removeDiacritics(trait).toLowerCase();
    }
    birthday = birthday === undefined ? birthdate : birthday;
    const areBirthdayEqual = !birthday && !this.birthday || !!birthday && !!this.birthday && dayjs(this.birthday).format("YYYYMMDD") === dayjs(birthday).format("YYYYMMDD");
    return Boolean(firstName) && Boolean(lastName) && clearTrait(this.firstName) === clearTrait(firstName) && clearTrait(this.lastName) === clearTrait(lastName) && areBirthdayEqual;
  }

  /**
   * Checks if patient SSN and given SSN are similar.
   *
   * "Similar" means they have the same numbers but may not have the same letter at the end.
   * A letter can appear when the SSN comes from the DMP: a letter D, T or N is put at the end
   * to indicate if the SSN comes from a Development, Test or productionN environment.
   *
   * Only the compared SSN is expected to have a letter, not the patient.
   *
   * @param ssn
   */
  hasSimilarSocialSecurityNumber(ssn) {
    return Boolean(this.socialSecurityNumber) && (this.socialSecurityNumber === ssn || this.socialSecurityNumber === ssn.slice(0, -1));
  }

  /**
   * Find the last JournalEvent which is an instance of the given Class.
   *
   * @param klass - The class of the journal events you are searching for.
   * @return Last JournalEvent corresponding to the given Class.
   */
  getLastJeOfClass(klass) {
    return getLastJeOfClass(this.activeJournalEvents, klass);
  }
  getJesOfClass(journalEventClass, ordering = "desc") {
    return getJesOfClass(this.activeJournalEvents, journalEventClass, ordering);
  }
  getJesOfClassSince(journalEventClass, date, ordering = "desc") {
    return getJesOfClassSince(this.journalEvents, journalEventClass, date, ordering);
  }
  getJesOfClassSinceYear(journalEventClass, numberOfYear, ordering = "desc") {
    /* The aim in the end is to directly call this method with the patient's relationship and
     * get rid of the `getJesOfClassSinceYear` call.
     * So this is temporary.
     */
    const journalEventRelation = get(this,
    // @ts-expect-error Will be fixed later
    `${journalEventClass.type.replace(/-./g, m => m[1].toUpperCase())}s`);
    if (journalEventRelation) {
      return getJesSince(journalEventRelation, dayjs().subtract(1, "y").toDate());
    }
    return getJesOfClassSinceYear(this.journalEvents, journalEventClass, numberOfYear, ordering);
  }
  getJesAt(journalEventClass, day, ordering = "desc") {
    const date = new Date(day).setHours(0, 0, 0, 0);
    return getJesOfClass(this.activeJournalEvents, journalEventClass, ordering).filter(je => new Date(je.occurredAt).setHours(0, 0, 0, 0) == date);
  }
  bmiAt(date) {
    const lastWeightMeasuredAtDate = this.weightMeasuredJournalEvents?.filter(je => dayjs(je.occurredAt).isSameOrBefore(date)).sort(sortBy("occurredAt", "desc"))[0];
    if (!lastWeightMeasuredAtDate) return null;
    return lastWeightMeasuredAtDate.bmi;
  }
  get followUpReasonId() {
    if (this.patientEnrolledJournalEvent?.followUpReason) return this.patientEnrolledJournalEvent.followUpReason;
    return "";
  }
  get followUpReasonRecord() {
    const id = `${this.followUpReasonId}`;
    if (id.length === 0) return null;
    return this.store.peekRecord("follow-up-reason", id);
  }
  get therapeuticalArea() {
    return this.followUpReasonRecord?.therapeuticalArea || this.healthCentre?.therapeuticalArea;
  }

  // TODO: remove this method and rename `followUpReasonRecord` to followUpReason
  // The codebase will have to be modified accordingly
  get followUpReason() {
    return this.followUpReasonRecord?.id || "";
  }
  get authorizesDmpAccess() {
    const je = getLastJeOfClass(this.activeJournalEvents, DmpAccessConsentUpdatedJournalEvent);
    return je?.agreed ?? true;
  }
  get lastVemsDeclaredJournalEvent() {
    return getLastJe(this.vemsDeclaredJournalEvents);
  }
  get lastOxygeneSaturationDeclaredJournalEvent() {
    return getLastJe(this.oxygeneSaturationDeclaredJournalEvents);
  }
  get lastTemperatureMeasuredJournalEvent() {
    return getLastJe(this.temperatureMeasuredJournalEvents);
  }
  get lastWeightMeasuredJournalEvent() {
    return getLastJe(this.weightMeasuredJournalEvents);
  }
  get lastHeightMeasuredJournalEvent() {
    return getLastJe(this.heightMeasuredJournalEvents);
  }
  get lastCapillarityBloodGlucoseMeasuredJournalEvent() {
    return getLastJe(this.capillarityBloodGlucoseMeasuredJournalEvents);
  }
  get lastRespiratoryRateMeasuredJournalEvent() {
    return getLastJe(this.respiratoryRateMeasuredJournalEvents);
  }
  get lastFeelingEvasDeclaredJournalEvent() {
    return getLastJe(this.feelingEvasDeclaredJournalEvents);
  }
  get lastMedicalEventJournalEvent() {
    return getLastJe(this.medicalEventJournalEvents);
  }
  get lastCompoundSurveyCompletedJournalEvent() {
    return getLastJe(this.compoundSurveyCompletedJournalEvents);
  }
  get lastBloodPressureSessionStartedJournalEvent() {
    return getLastJe(this.bloodPressureSessionStartedJournalEvents);
  }
  get lastBioExamResultsReceivedJournalEvent() {
    return getLastJe(this.bioExamResultsReceivedJournalEvents);
  }
  get lastTreatmentPrescriptionChangedJournalEvent() {
    return getLastJe(this.treatmentPrescriptionChangedJournalEvents.slice());
  }
  get lastCtcaeFilledJournalEvent() {
    return getLastJe(this.ctcaeFilledJournalEvents.slice());
  }
  get lastPreTreatmentFilledJournalEvent() {
    return getLastJe(this.preTreatmentFilledJournalEvents.slice());
  }
  get lastInterTreatmentFilledJournalEvent() {
    return getLastJe(this.interTreatmentFilledJournalEvents.slice());
  }
  get bioExamExpectedDosageChangedJournalEvent() {
    return getLastJe(this.bioExamExpectedDosageChangedJournalEvents.slice());
  }
  get lastDiabguideRecommendationComputedJournalEvent() {
    return getLastJe(this.diabguideRecommendationComputedJournalEvents.slice());
  }
  get lastMedicinesReconciliationChangedJournalEvent() {
    return getLastJe(this.medicinesReconciliationChangedJournalEvents.slice());
  }
  get lastReimbursementJournalEvent() {
    return getLastJeOfClass(this.activeJournalEvents, ReimbursementsRetrievedJournalEvent);
  }
  get lastStoolsNumberDeclaredJournalEvent() {
    return getLastJeOfClass(this.activeJournalEvents, StoolsNumberDeclaredJournalEvent);
  }
  get lastDmpUpdateDate() {
    return this.lastReimbursementJournalEvent?.occurredAt;
  }
  get tlsEligible() {
    return ["nephro-transplant", "nephro-mrc"].includes(this.followUpReasonId);
  }
  get tlsAgreedAt() {
    if (!this.tlsConsentUpdatedJournalEvent) return;
    if (!this.tlsConsentUpdatedJournalEvent.agreed) return;
    return this.tlsConsentUpdatedJournalEvent.occurredAt;
  }
  get tlsAgreed() {
    return this.tlsConsentUpdatedJournalEvent == undefined || this.tlsConsentUpdatedJournalEvent.agreed == true;
  }
  get tlsRefused() {
    return !!this.tlsConsentUpdatedJournalEvent && this.tlsConsentUpdatedJournalEvent.agreed == false;
  }
  get authorizesAppUsage() {
    return this.appUsageConsentUpdatedJournalEvent?.agreed ?? false;
  }
  async processChatNotifications() {
    return Promise.all(this.patientChatMessageSentJournalEvents.map(mes => mes.processNotifications()));
  }
  get prescriptionJournalEvents() {
    return [...this.bioExamPrescribedJournalEvents.slice(), ...this.medicalImagingPrescribedJournalEvents.slice(), ...this.medicationPrescribedJournalEvents.slice(), ...this.paramedicalCarePrescribedJournalEvents.slice(), ...this.tlsPrescribedJournalEvents.slice()];
  }
  get priorityBioExamLoincs() {
    const bioFrequencyJes = this.bioExamFrequencyChangedJournalEvents;
    if (!bioFrequencyJes.length) {
      const defaultPriorityExams = this.therapeuticalArea.priorityBioExams.map(exam => exam.id);
      return this.sortExamsByRank(defaultPriorityExams);
    }
    const ppsPriorityExams = [...new Set(bioFrequencyJes.flatMap(je => {
      return je.loincs;
    }))];
    return this.sortExamsByRank(ppsPriorityExams);
  }
  get hasDiabetoPathology() {
    return this.followUpReasonId?.startsWith("diabeto");
  }
  get hasDigestPathology() {
    return this.followUpReasonId?.startsWith("digest");
  }
  getLastBioExamResultWithDate(code) {
    const je = this.bioExamResultsReceivedJournalEvents.sort(sortBy("occurredAt", "desc")).find(je => je.result(code));
    return je && je.result(code) ? {
      result: je.result(code),
      occurredAt: je.occurredAt
    } : undefined;
  }
  sortExamsByRank(loincs) {
    return loincs.toSorted((loincA, loincB) => this.store.peekRecord("loinc", loincA)?.rank - this.store.peekRecord("loinc", loincB)?.rank);
  }
  get hasBreastCancer() {
    return this.followUpReason.includes("breast");
  }
  get hasHematoCancer() {
    return this.followUpReason == "onco-lymphoma-cancer" || this.followUpReason == "onco-myeloma-cancer";
  }
  get hasMetastaticCancer() {
    return this.followUpReason == "onco-breast-cancer";
  }
  get activeAbdominalAreaDeclaredJournalEvents() {
    return this.abdominalAreaDeclaredJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get activeThreeMonthsGoalsJournalEvents() {
    return this.threeMonthsGoalsJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get crisisPlan() {
    return getLastJeOfClass(this.activeJournalEvents, CrisisPlanDeclaredJournalEvent);
  }
  get lastPhqNineDeclaredJournalEvent() {
    return this.getLastJeOfClass(PhqNineDeclaredJournalEvent);
  }
  get lastBdiIiDeclaredJournalEvent() {
    return this.getLastJeOfClass(BdiIiDeclaredJournalEvent);
  }
  get lastAbdominalAreaDeclaredJournalEvent() {
    return this.activeAbdominalAreaDeclaredJournalEvents[0];
  }
  get lastThreeMonthsGoalsJournalEvents() {
    return this.activeThreeMonthsGoalsJournalEvents[0];
  }
  get activeDpCycleDeclaredJournalEvents() {
    return this.dpCycleDeclaredJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get activeHemodialysisSessionDeclaredJournalEvents() {
    return this.hemodialysisSessionDeclaredJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get isGeneric() {
    return this.followUpReasonId?.startsWith("generic");
  }
  get isTransplanted() {
    return this.followUpReasonId?.endsWith("transplant");
  }
  get isRenalTransplanted() {
    return this.isTransplanted && this.hasRenalPathology;
  }
  get isMrc() {
    return this.followUpReasonId === "nephro-mrc";
  }
  get isDonor() {
    return this.followUpReasonId === "nephro-donor";
  }
  get hasCardioHeartFailure() {
    return this.followUpReasonId === "cardio-heart-failure";
  }
  get hasCardioPathology() {
    return this.followUpReasonId?.startsWith("cardio");
  }
  get hasRenalPathology() {
    return this.followUpReasonId?.startsWith("nephro");
  }
  get hasPulmonaryPathology() {
    return this.followUpReasonId?.startsWith("pneumo");
  }
  get hasHepatoPathology() {
    return this.followUpReasonId?.startsWith("hepato");
  }
  get isCrohn() {
    return this.followUpReasonId === "digest-crohn";
  }
  get isRch() {
    return this.followUpReasonId === "digest-rch";
  }
  get shouldShowHlaContent() {
    return this.healthCentre?.shouldShowHlaContent && (this.isRenalTransplanted || this.isMrc);
  }
  get lastDpCycleDeclaredJournalEvent() {
    return this.activeDpCycleDeclaredJournalEvents[0];
  }
  get lastHemodialysisSessionDeclaredJournalEvent() {
    return this.activeHemodialysisSessionDeclaredJournalEvents[0];
  }
  get activeDas28CrpComputedJournalEvents() {
    return this.das28CrpComputedJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get activeDas28VsComputedJournalEvents() {
    return this.das28VsComputedJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get activeDas28CdaiComputedJournalEvents() {
    return this.das28CdaiComputedJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get activeDas28SdaiComputedJournalEvents() {
    return this.das28SdaiComputedJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get activePrArticulationsCountedJournalEvents() {
    return this.prArticulationsCountedJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get activePrFeelingEvaPatientDeclaredJournalEvents() {
    return this.prFeelingEvaPatientDeclaredJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get activePrFeelingEvaMedicDeclaredJournalEvents() {
    return this.prFeelingEvaMedicDeclaredJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get activeInflammatoryEruptionDeclaredJournalEvents() {
    return this.inflammatoryEruptionDeclaredJournalEvents.filter(je => !je.isArchived).toSorted(sortBy("occurredAt", "desc"));
  }
  get lastDas28CrpComputedJournalEvent() {
    return this.activeDas28CrpComputedJournalEvents[0];
  }
  get lastDas28VsComputedJournalEvent() {
    return this.activeDas28VsComputedJournalEvents[0];
  }
  get lastDas28CdaiComputedJournalEvent() {
    return this.activeDas28CdaiComputedJournalEvents[0];
  }
  get lastDas28SdaiComputedJournalEvent() {
    return this.activeDas28SdaiComputedJournalEvents[0];
  }
  get lastPrFeelingEvaPatientDeclaredJournalEvent() {
    return this.activePrFeelingEvaPatientDeclaredJournalEvents[0];
  }
  get lastPrArticulationCountedJournalEvent() {
    return this.activePrArticulationsCountedJournalEvents[0];
  }
  get lastPrFeelingEvaMedicDeclaredJournalEvent() {
    return this.activePrFeelingEvaMedicDeclaredJournalEvents[0];
  }
  get lastInflammatoryEruptionDeclaredJournalEvent() {
    return this.activeInflammatoryEruptionDeclaredJournalEvents[0];
  }
  get isProIrc() {
    return Boolean(this.proIrcStatusUpdatedJournalEvent?.included);
  }
  get isProIrcEligible() {
    return this.healthCentre.proIrc && this.followUpReason == "nephro-mrc";
  }
  get isMrcBordeaux() {
    return this.healthCentre.isMrcBordeaux;
  }
  get shouldShowDashboard() {
    if (this.therapeuticalArea?.id == "mental") {
      return true;
    }
    return this.isEnrolled;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "abilities", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "termsOfUse", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "birthName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "gender", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "occupation", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "email", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "birthday", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "socialSecurityNumber", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "insuredSocialSecurityNumber", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "birthrank", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "computedNationalHealthNumber", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "ippNumber", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "address", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "postcode", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "city", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "moreAddressInformation", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "phone", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "insuranceAldStartDate", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "insuranceCmuc", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "acceptedTermsOfUseVersion", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "uuid", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "birthFirstName", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "firstBirthFirstName", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "birthPlace", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "birthMunicipalityCode", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "insOid", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "insIdentityDocument", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "insValue", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "insKey", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "insStatus", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "insDocumentIsQualifying", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "clinicalStudyId", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "contactPreferences", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "passwordChangedAt", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "refreshTokensEnabled", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "twoFactorAuthenticationEnabled", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "associatedData", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "fileAttachments", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "journalEvents", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "patientChatMessageSentJournalEvents", [activeJournalEvents, _dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "patientEnrolledJournalEvent", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "patientDisenrolledJournalEvent", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "comorbiditiesAndAllergiesChangedJournalEvent", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "medicalHistoryChangedJournalEvent", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "adherencePredictionComputedJournalEvent", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "mobilePassiveDataDailySnapshotJournalEvent", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "medicalActFrequencyChangedJournalEvent", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "patientInformationTransmittedJournalEvent", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "tlsConsentUpdatedJournalEvent", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "proIrcStatusUpdatedJournalEvent", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "hospitalisationRiskPredictionComputedJournalEvent", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "spirometerAssociatedJournalEvent", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "mrcReplacementJournalEvent", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "personalNotesChangedJournalEvent", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "temperatureMeasuredJournalEvents", [activeJournalEvents, _dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "kfreFiveYearsComputedJournalEvents", [activeJournalEvents, _dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "kfreTwoYearsComputedJournalEvents", [activeJournalEvents, _dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "weightMeasuredJournalEvents", [activeJournalEvents, _dec57], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "heightMeasuredJournalEvents", [activeJournalEvents, _dec58], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "capillarityBloodGlucoseMeasuredJournalEvents", [activeJournalEvents, _dec59], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "respiratoryRateMeasuredJournalEvents", [activeJournalEvents, _dec60], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "adverseEventDeclaredJournalEvents", [activeJournalEvents, _dec61], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "feelingEvasDeclaredJournalEvents", [activeJournalEvents, _dec62], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "medicalEventJournalEvents", [activeJournalEvents, _dec63], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "compoundSurveyCompletedJournalEvents", [activeJournalEvents, _dec64], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "bloodPressureSessionStartedJournalEvents", [activeJournalEvents, _dec65], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "bioExamResultsReceivedJournalEvents", [activeJournalEvents, _dec66], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "bioExamFrequencyChangedJournalEvents", [activeJournalEvents, _dec67], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "medicationPrescribedJournalEvents", [activeJournalEvents, _dec68], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "tlsPrescribedJournalEvents", [activeJournalEvents, _dec69], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "alertTriggeredJournalEvents", [activeJournalEvents, _dec70], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "alertProcessedJournalEvents", [activeJournalEvents, _dec71], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "careGiverAddedJournalEvents", [activeJournalEvents, _dec72], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "toxicityPredictionComputedJournalEvent", [_dec73], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "bioExamPrescribedJournalEvents", [activeJournalEvents, _dec74], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "consultationReportWrittenJournalEvents", [activeJournalEvents, _dec75], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "connectedDeviceLinkedJournalEvents", [activeJournalEvents, _dec76], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "fileUploadedJournalEvents", [activeJournalEvents, _dec77], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "genericPrescriptionUploadedJournalEvents", [activeJournalEvents, _dec78], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor82 = _applyDecoratedDescriptor(_class.prototype, "medicalImagingPrescribedJournalEvents", [activeJournalEvents, _dec79], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class.prototype, "paramedicalCarePrescribedJournalEvents", [activeJournalEvents, _dec80], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class.prototype, "surveyCompletedJournalEvents", [activeJournalEvents, _dec81], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor85 = _applyDecoratedDescriptor(_class.prototype, "consultationPlannedJournalEvents", [activeJournalEvents, _dec82], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor86 = _applyDecoratedDescriptor(_class.prototype, "onlineConsultationReportWrittenJournalEvents", [activeJournalEvents, _dec83], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor87 = _applyDecoratedDescriptor(_class.prototype, "taskPlannedJournalEvents", [activeJournalEvents, _dec84], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor88 = _applyDecoratedDescriptor(_class.prototype, "recursiveTaskPlannedJournalEvents", [activeJournalEvents, _dec85], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor89 = _applyDecoratedDescriptor(_class.prototype, "taskProcessedJournalEvents", [activeJournalEvents, _dec86], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor90 = _applyDecoratedDescriptor(_class.prototype, "treatmentPrescriptionChangedJournalEvents", [activeJournalEvents, _dec87], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor91 = _applyDecoratedDescriptor(_class.prototype, "connectedDeviceAcquiredJournalEvents", [activeJournalEvents, _dec88], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor92 = _applyDecoratedDescriptor(_class.prototype, "therapeuticAssistanceSessionCompletedJournalEvents", [activeJournalEvents, _dec89], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor93 = _applyDecoratedDescriptor(_class.prototype, "bioExamExpectedDosageChangedJournalEvents", [activeJournalEvents, _dec90], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor94 = _applyDecoratedDescriptor(_class.prototype, "okChimioSnapshotCapturedJournalEvents", [activeJournalEvents, _dec91], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor95 = _applyDecoratedDescriptor(_class.prototype, "biologicalActRefundedJournalEvents", [activeJournalEvents, _dec92], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor96 = _applyDecoratedDescriptor(_class.prototype, "drugsAndDevicesRefundedJournalEvents", [activeJournalEvents, _dec93], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor97 = _applyDecoratedDescriptor(_class.prototype, "hospitalisationRefundedJournalEvents", [activeJournalEvents, _dec94], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor98 = _applyDecoratedDescriptor(_class.prototype, "medicalActRefundedJournalEvents", [activeJournalEvents, _dec95], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor99 = _applyDecoratedDescriptor(_class.prototype, "medicalImagingRefundedJournalEvents", [activeJournalEvents, _dec96], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor100 = _applyDecoratedDescriptor(_class.prototype, "ymrsDeclaredJournalEvents", [activeJournalEvents, _dec97], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor101 = _applyDecoratedDescriptor(_class.prototype, "qidsDeclaredJournalEvents", [activeJournalEvents, _dec98], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor102 = _applyDecoratedDescriptor(_class.prototype, "fastDeclaredJournalEvents", [activeJournalEvents, _dec99], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor103 = _applyDecoratedDescriptor(_class.prototype, "thymicEpisodeOccurredJournalEvents", [activeJournalEvents, _dec100], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor104 = _applyDecoratedDescriptor(_class.prototype, "diabguideRecommendationComputedJournalEvents", [activeJournalEvents, _dec101], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor105 = _applyDecoratedDescriptor(_class.prototype, "treatmentHistoryChangedJournalEvent", [_dec102], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor106 = _applyDecoratedDescriptor(_class.prototype, "appUsageConsentUpdatedJournalEvent", [_dec103], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor107 = _applyDecoratedDescriptor(_class.prototype, "dmpAccessConsentUpdatedJournalEvent", [_dec104], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor108 = _applyDecoratedDescriptor(_class.prototype, "dataSharingConsentUpdatedJournalEvent", [_dec105], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor109 = _applyDecoratedDescriptor(_class.prototype, "crisisPlanDeclaredJournalEvent", [_dec106], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor110 = _applyDecoratedDescriptor(_class.prototype, "digitalCareDeclaredJournalEvent", [_dec107], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor111 = _applyDecoratedDescriptor(_class.prototype, "oxygeneSaturationDeclaredJournalEvents", [activeJournalEvents, _dec108], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor112 = _applyDecoratedDescriptor(_class.prototype, "vemsDeclaredJournalEvents", [activeJournalEvents, _dec109], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor113 = _applyDecoratedDescriptor(_class.prototype, "medicinesReconciliationChangedJournalEvents", [activeJournalEvents, _dec110], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor114 = _applyDecoratedDescriptor(_class.prototype, "surveyRequestedJournalEvents", [activeJournalEvents, _dec111], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor115 = _applyDecoratedDescriptor(_class.prototype, "compoundSurveyFrequenciesChangedJournalEvent", [_dec112], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor116 = _applyDecoratedDescriptor(_class.prototype, "tlsTrialPeriodValidatedJournalEvent", [_dec113], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor117 = _applyDecoratedDescriptor(_class.prototype, "medics", [_dec114], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor118 = _applyDecoratedDescriptor(_class.prototype, "medicsPatients", [_dec115], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor119 = _applyDecoratedDescriptor(_class.prototype, "healthCentre", [_dec116], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor120 = _applyDecoratedDescriptor(_class.prototype, "hemodialysisSessionDeclaredJournalEvents", [_dec117], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor121 = _applyDecoratedDescriptor(_class.prototype, "dpCycleDeclaredJournalEvents", [_dec118], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor122 = _applyDecoratedDescriptor(_class.prototype, "abdominalAreaDeclaredJournalEvents", [_dec119], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor123 = _applyDecoratedDescriptor(_class.prototype, "threeMonthsGoalsJournalEvents", [_dec120], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor124 = _applyDecoratedDescriptor(_class.prototype, "lifestyleDeclaredJournalEvent", [_dec121], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor125 = _applyDecoratedDescriptor(_class.prototype, "jobsDeclaredJournalEvent", [_dec122], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor126 = _applyDecoratedDescriptor(_class.prototype, "disorderHistoryDeclaredJournalEvent", [_dec123], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor127 = _applyDecoratedDescriptor(_class.prototype, "referentLabUpdatedJournalEvent", [_dec124], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor128 = _applyDecoratedDescriptor(_class.prototype, "cnamProcessStartedJournalEvent", [_dec125], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor129 = _applyDecoratedDescriptor(_class.prototype, "das28CrpComputedJournalEvents", [_dec126], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor130 = _applyDecoratedDescriptor(_class.prototype, "das28VsComputedJournalEvents", [_dec127], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor131 = _applyDecoratedDescriptor(_class.prototype, "das28CdaiComputedJournalEvents", [_dec128], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor132 = _applyDecoratedDescriptor(_class.prototype, "das28SdaiComputedJournalEvents", [_dec129], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor133 = _applyDecoratedDescriptor(_class.prototype, "prArticulationsCountedJournalEvents", [_dec130], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor134 = _applyDecoratedDescriptor(_class.prototype, "prFeelingEvaPatientDeclaredJournalEvents", [_dec131], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor135 = _applyDecoratedDescriptor(_class.prototype, "prFeelingEvaMedicDeclaredJournalEvents", [_dec132], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor136 = _applyDecoratedDescriptor(_class.prototype, "inflammatoryEruptionDeclaredJournalEvents", [_dec133], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor137 = _applyDecoratedDescriptor(_class.prototype, "ctcaeFilledJournalEvents", [activeJournalEvents, _dec134], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor138 = _applyDecoratedDescriptor(_class.prototype, "preTreatmentFilledJournalEvents", [activeJournalEvents, _dec135], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor139 = _applyDecoratedDescriptor(_class.prototype, "interTreatmentFilledJournalEvents", [activeJournalEvents, _dec136], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor140 = _applyDecoratedDescriptor(_class.prototype, "anxietyFilledJournalEvents", [activeJournalEvents, _dec137], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor141 = _applyDecoratedDescriptor(_class.prototype, "preSurgerySurveyFilledJournalEvents", [activeJournalEvents, _dec138], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor142 = _applyDecoratedDescriptor(_class.prototype, "postSurgerySurveyFilledJournalEvents", [activeJournalEvents, _dec139], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor143 = _applyDecoratedDescriptor(_class.prototype, "rchSurveyFilledJournalEvents", [activeJournalEvents, _dec140], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor144 = _applyDecoratedDescriptor(_class.prototype, "crohnSurveyFilledJournalEvents", [activeJournalEvents, _dec141], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor145 = _applyDecoratedDescriptor(_class.prototype, "stoolsNumberDeclaredJournalEvents", [activeJournalEvents, _dec142], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor146 = _applyDecoratedDescriptor(_class.prototype, "ibdDiskSurveyFilledJournalEvents", [activeJournalEvents, _dec143], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor147 = _applyDecoratedDescriptor(_class.prototype, "diabetowiseDischargeCompletedJournalEvent", [_dec144], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasOngoingMiciSurveyProcedure", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "hasOngoingMiciSurveyProcedure"), _class.prototype), _class);
export { Patient as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.